import ChargerModule from 'components/chargerModule';
import UploadOrdersModule from './UploadOrdersModule';

const UploadOrders = () => {
  return (
    <ChargerModule
      headerInfo={{
        title: 'Cargue Masivo',
        subtitle: '',
        titleRoute: '/bulk-upload/type-of-charge'
      }}
      infoSideBar={{ position: 'bulkUpload' }}
    >
      <UploadOrdersModule />
    </ChargerModule>
  );
};

export default UploadOrders;